const ArrowLine = () => {
    return (
        <svg width="48" height="7" viewBox="0 0 48 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M48 3.36591L43 0.479154V6.25266L48 3.36591ZM0 3.36591V3.86591H43.5V3.36591V2.86591H0V3.36591Z" fill="white" />
        </svg>

    )
}
export default ArrowLine